import { render, staticRenderFns } from "./PrinterEditComp.vue?vue&type=template&id=bd9172d8&scoped=true&"
import script from "./PrinterEditComp.vue?vue&type=script&lang=ts&"
export * from "./PrinterEditComp.vue?vue&type=script&lang=ts&"
import style0 from "./PrinterEditComp.vue?vue&type=style&index=0&id=bd9172d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd9172d8",
  null
  
)

export default component.exports